import apiClient from '../apiClient';
import type { DateString } from '@/types/date';
import type { EntityType } from '@/types/enums';
import type { EntityHistoryPage } from '@/types/entityHistory';

export default {
    /**
     * The entity's history since `since` (by when each item reached the platform), newest first,
     * plus its latest parecer and latest KYX report however old.
     * `entityId` is a company's CNPJ (full or root), or a person's CPF or UUID.
     */
    getEntityHistory: async (
        entityType: EntityType,
        entityId: string,
        params: { since: DateString; page: number; page_size: number },
    ): Promise<EntityHistoryPage> => {
        return apiClient.get(`/entity-history/${entityType}/${encodeURIComponent(entityId)}`, { params });
    },
};
